import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ListValidation from './ListValidation';
import ValidationForm from './ValidationForm';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import DocsLink from '../../../../common/custom/DocsLink';
import ParentDocCard from '../../../common/ParentDocCard';

export default class ValidationsBuilder extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    validations: PropTypes.array,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  showPublishedMessage = () => {
    const { updatedCollections, collection } = this.props;
    const { uuid } = collection;
    if (updatedCollections && updatedCollections.includes(uuid)) {
      return <span className="fw-lighter unpublished-tag text-warning">(Not Published)</span>;
    }
    return '';
  };

  render() {
    const {
      actions,
      commonActions,
      collection,
      version,
      projectId,
      validations,
      collections,
      showValidationDeleteLoader,
      flag,
    } = this.props;
    return (
      <div className="row mx-auto">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('form')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title mb-0 pb-0">
                    Add Validation{' '}
                    {typeof collection !== 'undefined' && collection
                      ? ' To ' + collection.collectionTitle
                      : ''}
                    {this.showPublishedMessage()}
                  </h5>
                  <p className="mx-4 px-5">
                    Apply different validation rules to ensure that only valid data gets saved in a
                    collection.
                  </p>
                  <ValidationForm
                    actions={actions}
                    commonActions={commonActions}
                    collection={collection}
                    version={version}
                    projectId={projectId}
                    collections={collections}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('list')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title">Validations</h5>
                  <ListValidation
                    validations={validations}
                    actions={actions}
                    commonActions={commonActions}
                    projectId={projectId}
                    version={version}
                    collection={collection}
                    showValidationDeleteLoader={showValidationDeleteLoader}
                    flag={flag}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Validations</b>
          </h5>
          <p>
            Allows you to apply different validation rules on collection fields to ensure that only
            valid data gets saved in a collection. You can apply multiple validation rules as you
            want.
          </p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-collection/validations-in-collection" />
        </ParentDocCard>
      </div>
    );
  }
}
